import { render, staticRenderFns } from "./choose.vue?vue&type=template&id=f470e5c2&scoped=true"
import script from "./choose.vue?vue&type=script&lang=js"
export * from "./choose.vue?vue&type=script&lang=js"
import style0 from "./choose.vue?vue&type=style&index=0&id=f470e5c2&prod&lang=scss"
import style1 from "./choose.vue?vue&type=style&index=1&id=f470e5c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f470e5c2",
  null
  
)

export default component.exports